import { EventTrigger } from 'services/Analytics/core';

import { trackEventFixed } from './mainTrackers';

const ACCESS_CODE_ANALYTICS_NAMESPACE = 'access_code';

export const sendAnalyticAccessCodeLoaded = (isMobileDevice: boolean) => {
    trackEventFixed({
        // @ts-ignore
        event: `${ACCESS_CODE_ANALYTICS_NAMESPACE}__load`,
        eventLabel: isMobileDevice ? 'mobile' : 'desktop',
    });
};

export const sendAnalyticAccessCodeError = (error: string) => {
    trackEventFixed({
        // @ts-ignore
        event: `${ACCESS_CODE_ANALYTICS_NAMESPACE}__error`,
        eventLabel: { error },
    });
};

export const sendAnalyticAccessCodeCopied = () => {
    trackEventFixed({
        // @ts-ignore
        event: `${ACCESS_CODE_ANALYTICS_NAMESPACE}__${EventTrigger.click}`,
    });
};
